import DebounceInput from "../DebouncedSearch/DebouncedSearch"
import Button from "../Button/Button"
import PlusIcon from "../../assets/images/icons/PlusIcon.svg"
import React, { useEffect, useState } from "react"
import TasksTabTable from "./TasksTabTable"
import TableFooter from "../Pagination/TableFooter"
import { useDispatch } from "react-redux"
import { getAllTasksReq } from "../../features/tasks/tasks"
import { useMyContextLoading } from "../LoadingContextProvider/LoadingContextProvider"
import { initQueryData } from "../Filters/helper"
import Filters from "../Filters/Filters"
import { showSnackBar } from "../Snackbar/Snackbar"

const TasksPage = ({ setActiveTab, userId, setTaskId, taskId }) => {
  const dispatch = useDispatch()
  const [tasks, setTasks] = useState([])
  const [valuePagination, setValuePagination] = useState(10)
  const [pagePagination, setPagePagination] = useState(1)
  const [searchValue, setSearchValue] = useState('')
  const [pageCount, setPageCount] = useState(0)
  const [isUpdated, setIsUpdated] = useState(false)
  const [reqError, setReqError] = useState('')
  const [requestFilters, setRequestFilters] = useState([initQueryData])
  const { triggerLoading } = useMyContextLoading()

  useEffect(() => {
    const handleReqError = () => {
      reqError?.length > 0 && showSnackBar("error", reqError)
      setReqError('')
    }

    handleReqError()
  }, [reqError])

  const getAllTasks = async () => {
    triggerLoading(true)
    try {
      const limit = parseInt(valuePagination)
      const offset = (pagePagination - 1) * limit
      let filters = requestFilters[0]?.filterType?.length > 0 ? requestFilters : ""

      const response = await dispatch(getAllTasksReq({
        userId,
        limit,
        offset,
        searchQuery: searchValue,
        filters
      }))

      if (response.payload && response.payload.data) {
        setPageCount(response?.payload?.data?.meta?.pageCount)
        // /tasks/users/:userId -> getAllTasksByUser sends only limit/offset/pageCount.
        // /tasks-all does send `total`, which is why AllTasksPage can show the range.
        setTasks(response?.payload?.data?.tasks)
      }
    } catch (error) {
      setReqError(error)
    }
    triggerLoading(false)
  }

  const applyFilters = (newFilters) => {
    setRequestFilters(newFilters)
    setPagePagination(1)
  }

  useEffect(() => {
    getAllTasks()
  }, [])

  useEffect(() => {
    getAllTasks()
  }, [valuePagination, pagePagination, searchValue, isUpdated, requestFilters])

  useEffect(() => {
    setPagePagination(1)
  }, [valuePagination, searchValue])

  return (
    <div className="w-full">
      <div className="flex items-center justify-between px-5">
        <h5 className="text-xl font-bold">Tasks</h5>
        <div className="flex gap-2">
          <DebounceInput classes="h-10" searchValue={searchValue} setSearchValue={setSearchValue} placeholder="Search" />
          <Button classes="h-10 flex items-center justify-center" onClick={() => setActiveTab("addTask")}>
            <div className={"flex justify-center items-start gap-2"}>
              {
                <img src={PlusIcon} alt="plus" />
              }
              Add Task
            </div>
          </Button>
        </div>
      </div>
      <div className="flex justify-between w-full my-8 px-5 items-center">
        <Filters isFilterList={false} fetchByFilters={applyFilters}
          requestFilters={requestFilters}
          flow="tasks" />
      </div>
      <div className="m-5">
        <TasksTabTable data={tasks} setActiveTab={setActiveTab} setTaskId={setTaskId} setIsUpdated={setIsUpdated}
          isUpdated={isUpdated} taskId={taskId} />
        <TableFooter page={pagePagination} limit={valuePagination}
          pageCount={pageCount} setPage={setPagePagination} setLimit={setValuePagination} />
      </div>
    </div>
  )
}

export default TasksPage